// SpecialismSection.js
import React from 'react';
import '../assets/css/SpecialismSection.css'; 
const specialisms = [
  {
    title: 'Who Are We?',
    description: 'We are Phantom Global, a trusted homecare agency dedicated to providing personalised care that empowers individuals to live independently in the comfort of their own homes.',
  },
  {
    title: 'Why Choose Us?',
    description: 'Every client is different, which is why we create bespoke care plans that reflect individual needs and preferences. Our focus is on delivering a service that not only meets but exceeds expectations.',
  },
  {
    title: 'Contact Us',
    description: 'Let us help you or your loved ones with tailored care solutions that provide the support you need. Contact us today on 0207 139 5110 to find out more about our services and how we can make a difference in your life.',
  },
];



const SpecialismSectionTwo = () => {
  return (
    <div className="specialism-section">
      <div className="specialisms-container">
        {specialisms.map((specialism, index) => (
          <div key={index} className="specialism">
            <h3>{specialism.title}</h3>
            <p>{specialism.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecialismSectionTwo;
